import clsx from 'clsx';
import { FC } from 'react';
import { ICheckboxComponent } from '../../../types';
import styles from './styles.module.css';

const Checkbox: FC<ICheckboxComponent> = props => {
  const { label, disabled = false, errorMessage, ...inputProps } = props;

  const disabledClass = disabled ? styles.disabled : '';

  return (
    <>
      <label className={clsx(styles.labelWrapper, disabledClass)}>
        <input type="checkbox" disabled={disabled} {...inputProps} />
        <span className={styles.label}>{label}</span>
      </label>
      {Boolean(errorMessage) && <p className={clsx('help', 'is-danger')}>{errorMessage}</p>}
    </>
  );
};

export default Checkbox;
